import {AuthRoute} from '@common/auth/guards/auth-route';
import {ActiveWorkspaceProvider} from '@common/workspace/active-workspace-id-context';
import {RouteObject} from 'react-router';

export const driveRoutes: RouteObject[] = [
  {
    path: 'drive',
    element: (
      <ActiveWorkspaceProvider>
        <AuthRoute />
      </ActiveWorkspaceProvider>
    ),
    children: [
      {
        index: true,
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'folders/:hash',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'shares',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'recent',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'starred',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'trash',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'search',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'storage',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'photos',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'transfers',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'teams',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'links',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'memories',
        lazy: () => import('@app/memories/memories-layout'),
      },
      {
        path: 'memories/search',
        lazy: () => import('@app/memories/memories-layout'),
      },
      {
        path: 'memories/settings',
        lazy: () => import('@app/memories/memories-layout'),
      },
      {
        path: 'memories/people',
        lazy: () => import('@app/memories/memories-layout'),
      },
      {
        path: 'memories/people/:personId',
        lazy: () => import('@app/memories/memories-layout'),
      },
      {
        path: 'memories/places',
        lazy: () => import('@app/memories/memories-layout'),
      },
      {
        path: 'memories/places/:placeId',
        lazy: () => import('@app/memories/memories-layout'),
      },
      {
        path: 'memories/trips',
        lazy: () => import('@app/memories/memories-layout'),
      },
      {
        path: 'memories/trips/:tripId',
        lazy: () => import('@app/memories/memories-layout'),
      },
      {
        path: 'memories/events',
        lazy: () => import('@app/memories/memories-layout'),
      },
      {
        path: 'memories/events/:eventId',
        lazy: () => import('@app/memories/memories-layout'),
      },
      {
        path: 'memories/:memoryId',
        lazy: () => import('@app/memories/memories-layout'),
      },
    ],
  },
  {
    path: 'drive/s/:hash',
    lazy: () =>
      import('@app/drive/shareable-link/shareable-link-page/shareable-link-page'),
  },
];
